import React from "react";
import { Camera, ShieldCheck } from "lucide-react";

// Image authenticity + verification disclaimer
export function ImageDisclaimer({ compact = false }) {
  if (compact) {
    return (
      <div
        className="flex items-start gap-2 p-3 border rounded-sm"
        style={{ borderColor: "rgba(0, 194, 214, 0.18)" }}
        data-testid="image-disclaimer-compact"
      >
        <Camera size={12} className="text-[#9CA8B8] mt-0.5 shrink-0" />
        <p className="text-[10px] text-[#9CA8B8] leading-relaxed pg-mono uppercase tracking-[0.14em]">
          Vial / packaging may differ from image. Authentic Peptigen Labs products are sold only at peptigenlabs.co.uk
        </p>
      </div>
    );
  }

  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 gap-3"
      data-testid="image-disclaimer"
    >
      <div className="p-4 border rounded-sm" style={{ borderColor: "rgba(0, 194, 214, 0.22)" }}>
        <div className="flex items-center gap-2 mb-2">
          <Camera size={14} className="text-[#5EEAD4]" />
          <span className="pg-mono text-[10px] uppercase tracking-[0.22em] text-[#5EEAD4]">Image Notice</span>
        </div>
        <p className="text-xs text-[#9CA8B8] leading-relaxed">
          Product imagery is illustrative. The exact vial size, label layout, cap colour, or
          packaging supplied with your order may differ from the image shown. Strength, batch
          and intended use will always match the listing.
        </p>
      </div>
      <div className="p-4 border rounded-sm" style={{ borderColor: "rgba(166, 255, 0, 0.30)", backgroundColor: "rgba(166,255,0,0.04)" }}>
        <div className="flex items-center gap-2 mb-2">
          <ShieldCheck size={14} className="text-[#A6FF00]" />
          <span className="pg-mono text-[10px] uppercase tracking-[0.22em] text-[#A6FF00]">Authenticity</span>
        </div>
        <p className="text-xs text-[#9CA8B8] leading-relaxed">
          To guarantee you are receiving genuine Peptigen Labs material, purchase
          <span className="text-[#F7FAFC] font-medium"> direct from peptigenlabs.co.uk only</span>.
          We do not authorise resellers, marketplaces or third-party stock holders. Independent
          affiliates may <em>refer</em> you here — your Order is still fulfilled direct by
          Peptigen Labs Ltd.
        </p>
      </div>
    </div>
  );
}

export default ImageDisclaimer;
